import globalTheme from '../global'

const Switch = {
	MuiSwitch: {
		styleOverrides: {
			input: {
				left: -4,
				width: 68,
			},
			root: {
				height: 32,
				padding: 0,
				width: 68,
			},
			switchBase: {
				left: 4,
				padding: 0,
				top: 4,
				'&.Mui-checked': {
					transform: 'translateX(36px)',
					'&+.MuiSwitch-track': {
						backgroundColor: 'transparent',
						border: '1px solid ' + globalTheme.palette.primary.main,
						opacity: 1,
					},
					'& .MuiSwitch-input': {
						left: -40,
					},
				},
			},
			thumb: {
				backgroundColor: globalTheme.palette.primary.main,
				boxShadow: 'none',
				height: 24,
				width: 24,
			},
			track: {
				backgroundColor: globalTheme.palette.grey.light,
				border: '1px solid transparent',
				borderRadius: 16,
				opacity: 1,
				transition:
					'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
			},
		},
	},
}

export default Switch
